import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FocusInputDirective } from '@core/directives/focus-input.directive';

@Component({
    selector: 'app-editable-input-field-v1',
    imports: [FocusInputDirective, CommonModule, FormsModule],
    templateUrl: './editable-input-field-v1.component.html',
    styleUrls: ['./editable-input-field-v1.component.scss']
})
export class EditableInputFieldV1Component {
  @Input() text: string = '';
  @Input() textClass: 'default' | 'modified' = 'default'
  @Input() maxInputLength: number | null;
  @Output() textChange = new EventEmitter<string>();

  initialText: string = '';
  showText: boolean = true;

  ngOnInit() {
    // Initialize showText based on whether text is empty
    this.showText = !this.text || this.text.trim() === '';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['text']) {
      const latestChanges = changes['text'].currentValue as string;
      this.initialText = latestChanges ? latestChanges.trim() : '';
      // Show input only if text is empty
      this.showText = !latestChanges || latestChanges.trim() === '';
    }
  }

  saveText() {
    const trimmedText = this.text.trim();
    this.text = trimmedText;
    this.initialText = trimmedText;
    this.textChange.emit(trimmedText);

    // Hide input if text is not empty, show if empty
    this.showText = trimmedText === '';
  }

  onEnter(event: Event) {
    if ((event as KeyboardEvent).key === 'Enter') {
      this.saveText();
    }
  }
}
